import { logger } from '@src/app/logger';
import { v4 as uuidv4 } from 'uuid';

const deviceIdKey = 'device_id';

export function getDeviceId(): string {
    const existingDeviceId = localStorage.getItem(deviceIdKey);

    if (existingDeviceId) {
        return existingDeviceId;
    }

    const newDeviceId = uuidv4();
    localStorage.setItem(deviceIdKey, newDeviceId);

    return newDeviceId;
}

// Explanantion: https://www.notion.so/superbet/Percentage-rollout-with-app-config-and-deviceId-7ce4932ce8b0454d870ac60e9975e76d#a8368be2d0b24235bcc489a21e6ce1d6
export function getIsFFEnabledForDeviceId(deviceUuid: string, remoteConfigValue: string | undefined): boolean {
    if (!remoteConfigValue) {
        return false;
    }
    try {
        const hexNumber = deviceUuid.slice(-2);
        const decimalValue = parseInt(hexNumber, 16);

        const intervalWithFlagEnabled = remoteConfigValue.split('-').map((stringVal) => parseInt(stringVal));

        return intervalWithFlagEnabled[0] <= decimalValue && decimalValue <= intervalWithFlagEnabled[1];
    } catch (e) {
        logger.error(e as Error);
        return false;
    }
}
